import { render, staticRenderFns } from "./Certification.vue?vue&type=template&id=9047095e&scoped=true"
import script from "./Certification.vue?vue&type=script&lang=js"
export * from "./Certification.vue?vue&type=script&lang=js"
import style0 from "./Certification.vue?vue&type=style&index=0&id=9047095e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9047095e",
  null
  
)

export default component.exports